import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "../../App";
import partnerImg from "../graphic/Images/partner.png";
import partnerImgwebp from "../graphic/Images/partner.webp";

export default function TrustedPartner() {
  let tablet = useMediaQuery(theme.breakpoints.down("md"));

  const PartnerImage = () => {
    return (
      <>
        <picture>
          <source srcSet={partnerImgwebp} type="image/webp" />
          <img
            src={partnerImg}
            alt="Partner"
            style={{ height: "85px", width: "85px" }}
          />
        </picture>
      </>
    );
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: "320px",
        px: { xs: "12px !important", sm: "16px !important" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          pt: "70px",
        }}
      >
        {tablet && (
          <div style={{ marginBottom: "50px" }}>
            <PartnerImage />
          </div>
        )}
        <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
          <Typography
            variant="partnerTitle"
            sx={{
              mb: "50px",
              maxWidth: { xs: "310px", sm: "310px", md: "100%" },
            }}
          >
            Spolehlivý dopravce už přes 30 let
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            mx: { xs: "0px", sm: "50px", md: "60px" },
            alignContent: "center",
            alignItems: "center",
            pb: "50px",
          }}
        >
          {!tablet && (
            <div style={{ marginRight: "50px" }}>
              <PartnerImage />
            </div>
          )}
          <Typography variant="partnerText" sx={{ textAlign: "left" }}>
            Jmenuji se Ing. Petr Charvát a v autodopravě podnikám od roku 1992.
            V průběhu let se počet mých aktivit rozrůstal a v současnosti
            zajišťuji přepravu materiálů ve všech objemech. Při své činnosti si
            zakládám na spolehlivosti a férovém jednání, což mohou dosvědčit
            stovky spokojených zákazníků.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
